<template>
  <div>
    <v-snackbar 
      v-model="toaster.visible"
      :timeout="timeout"
			:color="toaster.color"
			top
    >
      <span :class="toaster.fontColor ?'fontBlack' : 'fontWhite'">{{ toaster.message }}</span>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Toaster',
  data () {
		return {
			timeout: 3000,
		}
  },
  computed: {
    ...mapState('Shared', {
      toaster: 'toaster'
    }),
    routeNotAvailable () {
      return /Sem permissão/.test(this.toaster.message)
    }
  }
}
</script>
<style lang="scss">
.fontBlack {
  color: var(--black) !important;
}

.fontWhite {
  color: var(--white) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Toast.vue